// extracted by mini-css-extract-plugin
export var cardIcon = "_ai-4";
export var checkboxCard = "_ai-0";
export var checkboxCardSelected = "_ai-1";
export var disabled = "_ai-2";
export var outerBorder = "_ai-3";
export var spacerMedium = "_ai-7";
export var spacerSmall = "_ai-6";
export var spacerXsmall = "_ai-5";